var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-layout',{attrs:{"redirectTo":"home"}},[_c('contact-content',{attrs:{"isFromContact":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }